document.addEventListener('DOMContentLoaded', function () {
  // Gallery lightbox: click a gallery image to view it larger
  var galleryItems = document.querySelectorAll('[data-lightbox-src]');
  var lightbox = document.querySelector('[data-lightbox]');
  if (galleryItems.length && lightbox) {
    var lightboxImg = lightbox.querySelector('[data-lightbox-img]');
    var lightboxCaption = lightbox.querySelector('[data-lightbox-caption]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');

    galleryItems.forEach(function (item) {
      item.addEventListener('click', function () {
        lightboxImg.src = item.getAttribute('data-lightbox-src');
        lightboxCaption.textContent = item.getAttribute('data-lightbox-caption') || '';
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    function closeLightbox(){
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  // Gallery filter tabs
  var filterBtns = document.querySelectorAll('[data-gallery-filter]');
  var galleryCards = document.querySelectorAll('[data-gallery-category]');
  if (filterBtns.length) {
    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var filter = btn.getAttribute('data-gallery-filter');
        galleryCards.forEach(function (card) {
          var match = filter === 'all' || card.getAttribute('data-gallery-category') === filter;
          card.style.display = match ? '' : 'none';
        });
      });
    });
  }
});
